import { render, staticRenderFns } from "./CartMenuIcon.vue?vue&type=template&id=556d475f&scoped=true"
import script from "./CartMenuIcon.vue?vue&type=script&lang=js"
export * from "./CartMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./CartMenuIcon.vue?vue&type=style&index=0&id=556d475f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d475f",
  null
  
)

export default component.exports